export default __webpack_public_path__ + "static/media/ruleGrey.4c0c68f1.svg";